import FormulateInputRichEditor from './FormulateInputRichEditor.vue'

export default function VueFormulateRichEditorPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateInputRichEditor,
    },
    library: {
      'rich-editor': {
        classification: 'text',
        component: 'FormulateInputRichEditor',
      },
    },
  })
}
